/**
 * @typedef {string} ModuleType
 **/

enum ModuleTypes {
  TRADE_IN = "trade_in",
  BOOK_TEST_DRIVE = "book_test_drive",
  PRICE_ALERT = "price_alert",
  SIMILAR_CARS = "similar_cars_widget",
  CUSTOM = "custom",
  CALL = "call",
  MESSAGE = "message",
  ROUTER = "router",
}

export default ModuleTypes
